export default __webpack_public_path__ + "images/lv-9a5d132cec13c3e033f02e906883f06b.svg";